import { BaseButton } from './button'
import { BaseControls } from './controls'
import { BaseList } from './list'
import { BaseWrapperScreen } from './wrapper'

export const ScreenDefault = {
  Root: BaseWrapperScreen,
  Controls: BaseControls,
  List: BaseList,
  Button: BaseButton,
}
